import { SHOW_SALON_GACHA_TICKETS } from '../../constants/featureFlags';
import { getFormattedAmount } from 'utils';
export default function GachaTicketDiscount({
  payment,
}: {
  payment?: {
    gachaTicketDiscount?: number;
    gachaTicketDiscountAtUse?: number;
  };
}) {
  if (!SHOW_SALON_GACHA_TICKETS || !payment?.gachaTicketDiscountAtUse)
    return null;
  return (
    <div className="my-3 border-y border-neutral-200 bg-white py-3 font-ticket-serif">
      <p>
        ガチャ券の割引：−{getFormattedAmount(payment.gachaTicketDiscount || 0)}
        円
      </p>
      {(payment.gachaTicketDiscount || 0) <
        payment.gachaTicketDiscountAtUse && (
        <p className="mt-1 text-xs">
          残りの支払額までの割引です。券は使用済みで、持ち越しはありません。
        </p>
      )}
    </div>
  );
}
